import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../hooks/useTranslation'
import { useCurrentLanguage } from '../hooks/useTranslation'

/**
 * Extractable local-therapy answer for AI search / featured snippets.
 * Reused on home, about, and contact so Boca Raton + Florida facts stay consistent.
 */
export default function LocalAnswerBlock ({ className = '', compact = false }) {
  const t = useTranslation()
  const language = useCurrentLanguage()
  const locationsPath = language === 'pt' ? '/pt/locations' : language === 'en' ? '/en/locations' : '/locations'
  const contactPath = language === 'pt' ? '/pt/contact' : language === 'en' ? '/en/contact' : '/contact'

  const heading = t('locations.answer.heading')
  const text = t('locations.answer.text')
  if (!heading || !text) return null

  return (
    <section
      className={`bg-white border-y border-primary-darkGreen/10 ${compact ? 'py-8' : 'py-12'} ${className}`}
      aria-labelledby="local-therapy-answer-heading"
      data-seo-ready="1"
    >
      <div className={`mx-auto px-4 sm:px-6 lg:px-8 ${compact ? 'max-w-4xl' : 'max-w-5xl'}`}>
        <h2
          id="local-therapy-answer-heading"
          className="text-2xl sm:text-3xl font-bold text-primary-darkGreen mb-4"
        >
          {heading}
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-5">{text}</p>
        <p className="flex flex-wrap gap-x-4 gap-y-2 text-sm sm:text-base">
          <Link
            to={locationsPath}
            className="font-semibold text-primary-darkGreen hover:underline underline-offset-2"
          >
            {t('locations.hero.title')}
          </Link>
          <Link
            to={contactPath}
            className="font-semibold text-primary-darkGreen hover:underline underline-offset-2"
          >
            {t('locations.cta.contact')}
          </Link>
        </p>
      </div>
    </section>
  )
}
